<template>
  <el-dialog
    title="选择AI评阅方式"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div v-loading="loading" class="ai-type-dialog">
      <div v-if="options.length" class="ai-type-list">
        <el-radio-group v-model="selectedAiType">
          <div
            v-for="item in options"
            :key="item.aiType"
            class="ai-type-item"
          >
            <el-radio :label="item.aiType" border>
              <span class="ai-type-name">{{ item.aiName }}</span>
              <el-tag
                v-if="item.free"
                type="success"
                size="mini"
                effect="plain"
                class="ai-type-tag"
                >免费</el-tag
              >
              <el-tag
                v-else
                type="warning"
                size="mini"
                effect="plain"
                class="ai-type-tag"
                >¥{{ item.aiFee }}/次</el-tag
              >
            </el-radio>
          </div>
        </el-radio-group>

        <template v-if="selectedAiType === 'gzd'">
          <div class="ai-major-block">
            <span class="ai-major-label">专业：</span>
            <el-select
              v-model="selectedMajorCode"
              filterable
              clearable
              size="small"
              placeholder="请选择专业"
              class="ai-major-select"
            >
              <el-option
                v-for="m in majors"
                :key="m.majorCode"
                :label="m.majorName"
                :value="m.majorCode"
              >
              </el-option>
            </el-select>
            <span v-if="majorErr" class="ai-major-err">请选择专业</span>
          </div>
        </template>
      </div>
      <el-empty v-else-if="!loading" description="暂无可用的AI评阅方式"></el-empty>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button size="mini" type="primary" :loading="submitting" @click="handleConfirm"
        >开始AI评阅</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  selectAiType,
  gzdMajors,
} from "@/api/ai";

export default {
  name: "AiTypeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    payMethod: {
      type: String,
      default: "paper", // "paper" | "degree"
    },
    thesisId: {
      type: [String, Number],
      default: "",
    },
    attPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      options: [],
      selectedAiType: "",
      majors: [],
      selectedMajorCode: "",
      majorErr: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    currentOption() {
      return this.options.find((o) => o.aiType === this.selectedAiType) || {};
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData();
      }
    },
    selectedAiType(val) {
      this.majorErr = false;
      if (val === "gzd") {
        this.loadMajors();
      } else {
        this.selectedMajorCode = "";
      }
    },
  },
  methods: {
    async initData() {
      this.loading = true;
      this.submitting = false;
      this.selectedAiType = "";
      this.selectedMajorCode = "";
      this.options = [];
      this.majors = [];
      try {
        const res = await selectAiType(this.payMethod);
        this.options = Array.isArray(res) ? res : [];
        // 只有一个可选方式时自动选中，但仍展示弹窗让用户确认
        if (this.options.length === 1) {
          this.selectedAiType = this.options[0].aiType;
        }
      } catch (e) {
        this.$message.error((e && e.msg) || "获取AI评阅方式失败，请稍后重试");
        // 报错保持弹窗打开
      } finally {
        this.loading = false;
      }
    },
    async loadMajors() {
      if (this.majors.length) return;
      try {
        const res = await gzdMajors();
        this.majors = Array.isArray(res) ? res : [];
      } catch (e) {
        this.$message.error((e && e.msg) || "获取专业列表失败，请稍后重试");
      }
    },
    handleConfirm() {
      if (!this.selectedAiType) {
        this.$message.error("请选择AI评阅方式");
        return;
      }
      if (this.selectedAiType === "gzd" && !this.selectedMajorCode) {
        this.majorErr = true;
        this.$message.error("请选择专业");
        return;
      }
      // 提交由父组件接管（父组件会关闭本弹窗），弹窗内不再维护 loading，避免 submitting 卡死
      this.$emit("confirm", {
        aiType: this.selectedAiType,
        majorCode: this.selectedAiType === "gzd" ? this.selectedMajorCode : "",
        aiFee: this.currentOption.aiFee,
        free: this.currentOption.free,
      });
    },
    handleClosed() {
      this.options = [];
      this.selectedAiType = "";
      this.selectedMajorCode = "";
      this.majors = [];
      this.majorErr = false;
    },
  },
};
</script>

<style scoped lang="scss">
.ai-type-dialog {
  min-height: 120px;
  .ai-type-list {
    .ai-type-item {
      margin-bottom: 14px;
      .el-radio {
        width: 100%;
        margin-right: 0;
        display: flex;
        align-items: center;
        height: 44px;
        .ai-type-name {
          font-size: 14px;
          font-weight: 500;
          margin-right: 8px;
        }
        .ai-type-tag {
          margin-left: 4px;
        }
      }
    }
    .ai-major-block {
      margin: 6px 0 0 10px;
      display: flex;
      align-items: center;
      .ai-major-label {
        font-size: 14px;
        color: #606266;
      }
      .ai-major-select {
        width: 260px;
      }
      .ai-major-err {
        color: #f56c6c;
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }
}
</style>
